import React from 'react';
import { Platform } from 'react-native';

import {
  Container,
  ModalContent,
  ModalFooter,
  ContentExplication,
  Section,
  Item,
  ItemTitle,
  ItemName,
  CheckRateText,
  CheckRateTextBold,
  TitleCheckRateTextBold,
  ContainerImage,
  BenefitsBanner,
  //RouletteBanner,
} from './styles';

import { Button } from '../../../Interface/Forms/Buttons/Button';
import { RFValue } from 'react-native-responsive-fontsize';
import { useHelpers } from '../../../../context/helpers';
import { Badge } from '../../../Interface/Badges/Badge';
import { useTheme } from 'styled-components/native';
import benefitsImage from '../../../../assets/images/banners/beneficios.webp';
import { useNavigation } from '@react-navigation/native';
//import {useNavigation} from '@react-navigation/native';

interface Props {
  showModal: boolean;
  onDismiss: () => void;
  taxa: number;
  value: number;
  liters: number;
  cashback: number;
  isCard?: boolean;
}

export function ServiceTaxModal({
  showModal,
  onDismiss,
  taxa,
  value,
  liters,
  cashback,
  isCard
}: Props) {
  const { formatNumberToLocaleAmount } = useHelpers();
  const navigation = useNavigation();
  const isWebview = Platform.OS === 'web';


  const theme = useTheme();
  /**function handleRoulette() {
    onDismiss();
    navigation.navigate('Roulette');
  }**/
  function handleOpenBeneficios() {
    onDismiss();
    navigation.navigate('Beneficios' as never);
  }

  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      {!isWebview && (
        <ContainerImage activeOpacity={0.9} onPress={handleOpenBeneficios}>
          <BenefitsBanner source={benefitsImage} resizeMode="contain" />
        </ContainerImage>
      )}
      <ModalContent>
        <ContentExplication
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{ paddingBottom: RFValue(12) }}>
          <Section style={{ paddingBottom: RFValue(6) }}>
            {!isCard && <Item>
              <ItemTitle>Taxa de serviço por litro:</ItemTitle>
              <ItemName>{formatNumberToLocaleAmount(taxa / liters)}</ItemName>
            </Item>}
            <Item>
              <ItemTitle>{isCard ? "CET" : "Preço total da taxa:"}</ItemTitle>
              <ItemName>{isCard ? taxa.toFixed(2).replace(".", ",") + "% ao mês" : formatNumberToLocaleAmount(taxa)}</ItemName>
            </Item>
            <Item>
              <ItemTitle>Você está pagando:</ItemTitle>
              <ItemName>{formatNumberToLocaleAmount(value)}</ItemName>
            </Item>
            <Item>
              <ItemTitle>Você ganhará de cashback:</ItemTitle>
              <ItemName>
                <Badge text={`${cashback} baratinhaZ`} textStyle={{ color: theme.colors.shape }} containerStyle={{
                  backgroundColor: theme.colors.blue,
                  borderColor: theme.colors.blue,

                }} />
              </ItemName>
            </Item>


            {/**<RouletteBanner activeOpacity={1} onPress={handleRoulette} />**/}
          </Section>
          <TitleCheckRateTextBold>
            Por que há uma taxa no pagamento com PIX e cartão?
          </TitleCheckRateTextBold>

          <CheckRateTextBold>
            Sobre a taxa do PIX:
          </CheckRateTextBold>

          <CheckRateText>
            Para manter a segurança das transações e garantir o funcionamento do serviço, é aplicada uma pequena taxa em pagamentos via Pix. Essa taxa cobre custos operacionais, tecnológicos e de processamento, permitindo que continuemos oferecendo uma experiência rápida, segura e eficiente para você.
          </CheckRateText>

          <CheckRateTextBold>
            Sobre a taxa da operadora de cartão:
          </CheckRateTextBold>

          <CheckRateText>
            Ao escolher pagar com cartão, a taxa exibida no checkout é uma cobrança direta da operadora de pagamento. Essa taxa é padrão em transações com cartão de crédito ou débito e não é recebida pela Baratão. Nosso compromisso continua sendo oferecer os melhores preços e benefícios, independentemente da forma de pagamento escolhida.
          </CheckRateText>

          <CheckRateTextBold>
            Quer economizar ainda mais? Temos uma oferta especial para você!
          </CheckRateTextBold>

          <CheckRateText>
            Use o cupom <Badge text='minhaeconomia' textStyle={{ color: theme.colors.shape }} containerStyle={{
              backgroundColor: theme.colors.blue,
              borderColor: theme.colors.blue
            }} /> e ganhe um desconto exclusivo na sua próxima compra. É o nosso jeito de agradecer por fazer parte do Baratão!
          </CheckRateText>

          <CheckRateText>
            Agradecemos sua compreensão e preferência. Juntos, seguimos inovando a forma como o Brasil abastece, com transparência e economia!
          </CheckRateText>

        </ContentExplication>

        <ModalFooter>
          <Button title="Entendi" enabled onPress={onDismiss} />
        </ModalFooter>
      </ModalContent>
    </Container >
  );
}
